export enum StatisticType {
    HOSPITALITY = 'HOSPITALITY',
    INTEGRATION = 'INTEGRATION',
    PORTAL = 'PORTAL',
}

export type SalesStatistic = {
    ticketsAverage: number;
    ticketsToday: number;
    ticketsTomorrow: number;
    ticketsYesterday: number;
};
